import { Model } from "@vuex-orm/core";

export class News extends Model {
    static get entity() {
        return "news"
    }

    static fields() {
        return {
            "id": this.attr(null),
            "news_titile": this.string(""),
            "description": this.string(""),
            "keyImg": this.attr(null),
            "create_by": this.attr(null),
            "update_by": this.attr(null),
            "createdAt": this.attr(null),
            "updatedAt": this.attr(null),
        }
    }

    static get apiConfig() {
        return {
            actions: {
                findAll(params = {}) {
                    return this.get('/news', { params });
                },

                create(body) {
                    return this.post('/news', body);
                },

                update(id, body) {
                    return this.put(`/news/${id}`, body);
                },

                destroy(id) {
                    return this.delete(`/news/${id}`, { delete: id });
                }
            }
        };
    }
}